// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"315":"b305515b01da275c","444":"bb3a5f9904296ce7","714":"bf2443b112bc9a4b","928":"1cf466168d130645"}[chunkId] + ".js";
};